export const contractEnvelopeUserColumns = [
  { label: 'Assinante', value: 'signable_type', className: 'w-10' },
  { label: 'Nome', value: 'full_name' },
  { label: 'Assinado em', value: 'signed_at', className: 'w-10' },
]
